import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const ENTRY = `${API_URL}/objectives`;

getCounts.operation = 'READ';
export function getCounts(objectiveIds) {
    return post(`${ENTRY}/comment-counts`, {
        postData: objectiveIds,
    });
}
